define([
    "util"
], function (
    Util
) {
    class LegacyParallelGlobalService {

        constructor (args) {
            if (!args || typeof args !== "object" || !args.dao) {
              throw new TypeError("Invalid args argument");
            }
            this.dao = args.dao;
        }

        getDAO () { return this.dao; }

        async getAccess() {
            if (Util.legacyCCIsRemoved()) {
                return;
            }
            return await this.getDAO().getLegacyParallelAPI("clusterAccess", null, null, null, {fetchAbortable: true, fetchTimeoutMillis: Util.defaultTimeout()});
        }

        async putAccess() {
            if (Util.legacyCCIsRemoved()) {
              return;
            }
            return await this.getDAO().putLegacyParallelAPI("clusterAccess", null, null, {}, {fetchAbortable: true, fetchTimeoutMillis: Util.defaultTimeout()});
        }

        async features() {
            if (Util.legacyCCIsRemoved()) {
              return;
            }
            return await this.getDAO().putLegacyParallelAPI("features", null, null, null, {fetchAbortable: true, fetchTimeoutMillis: Util.defaultTimeout()});
        }
    }
    return LegacyParallelGlobalService;
});
